// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1hO2G","row":"ProcedureTreatmentSummary_row__3FpZi"};